import Section from "../../common/section";
import { forwardRef, type LegacyRef, useEffect, useState } from "react";
import TagFilter from "./tagFilter";
import Blog from "./blog";
import { getSectionPaddingClass, getThemeClass } from "~/styles/styles";
import { useSearchParams } from "next/navigation";
import { type ArticleListProps } from "~/app/insights/page";
import type { DrupalNode, JsonApiResource } from "next-drupal";

export type FilterType = {
  tags?: string[];
};

const BlogArticleSection = (
  { allTags: { tags }, articles }: ArticleListProps,
  ref: LegacyRef<HTMLElement> | undefined,
) => {
  const searchParams = useSearchParams(); // get url tag , else filter as []

  const [filter, setFilter] = useState<FilterType>({
    tags: searchParams.getAll("tag"),
  });

  // update filter when searchParams changes in the case of changed page
  useEffect(() => {
    setFilter({
      tags: searchParams.getAll("tag"),
    });
  }, [searchParams, setFilter]);

  const filteredBlog = articles?.filter((blog) => {
    const activeFilters = [
      ...(filter.tags ?? []),
    ];
    if (activeFilters.length === 0) return true; // show all blogs when no filters applied

    // check if blog matches any active filter
    const tagMatches = blog.field_tags.some((tag: { name: string }) =>
      activeFilters.includes(tag.name),
    );

    return tagMatches;
  });

  const resetFilters = (type: keyof FilterType, tag: string) => {
    const filterType = {
      tag: "tags",
    };

    if (type in filterType) {
      // reset all filters, apply one clicked tag from the blog --- same behaviour as current ct.com.au
      setFilter({
        tags: [],
        [filterType[type as keyof typeof filterType] as string]: [tag],
      });
      // reset only the selected category, apply multiple tags
      // setFilter((prevFilters) => ({
      //   ...prevFilters,
      //   [filterType[type as keyof typeof filterType]]: [tag],
      // }));
    }
  };

  return (
    <>
      <div
        className={`border-t-4 border-white bg-purpleblue p-8 py-4 font-secondary xs:py-6 ml:px-12 lg:px-16`}
      >
        <TagFilter {...{ filter, setFilter, tags }} />
      </div>

      <Section
        ref={ref}
        className={`${getThemeClass("light")} ${getSectionPaddingClass("base")}`}
      >
        {/* blog layout - 2xl:max-w-screen-2xl or max:container or 2xl:max-w-[1650px] */}
        <div className="mx-auto grid gap-x-5 gap-y-7 md:grid-cols-2 xl:grid-cols-3 2xl:max-w-screen-2xl">
          {filteredBlog?.map((blog: JsonApiResource, i: number) => (
            <Blog
              key={i}
              {...{ blog, resetFilters }}
              feature={i === 0}
              variant="image-bg"
            />
          ))}
        </div>
      </Section>
    </>
  );
};

export default forwardRef(BlogArticleSection);
